import React, { Component } from 'react';

import { UserContext } from 'constants/user-context';

import { OptimizedImage } from 'components/OptimizedImage';

import { HandleNotification } from 'utils';
import { buildImgUrl } from 'utils/image/buildImgUrl';

import { ErrorHandlerStyle, ErrorHandlerTitle, ErrorHandlerMessage, ErrorHandlerCode } from 'styles';

interface ErrorHandlerState {
    error: any;
    errorId: string | null;
    location: string | null;
    fromGdse: boolean;
}

interface ErrorHandlerProps {
    children?: React.ReactNode;
    type?: string;
}

export class ErrorHandler extends Component<ErrorHandlerProps, ErrorHandlerState> {
    static getDerivedStateFromError(error: any) {
        return { error, errorId: null, location: window.location.href, fromGdse: true };
    }

    state: ErrorHandlerState = {
        error: null,
        errorId: null,
        location: null,
        fromGdse: false,
    };

    componentDidUpdate(_: any, prevState: ErrorHandlerState) {
        if (prevState.location !== window.location.href) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                error: null,
                location: window.location.href,
            });
        }
    }

    componentDidCatch(error: any, errorInfo: any) {
        let errorId: string | undefined;
        type LogType = 'warn' | 'info' | 'error' | 'debug' | string;
        const type: LogType = error.type || 'fatal';
        const logMethod = window.Log?.[type as keyof typeof window.Log] as Function | undefined;
        if (typeof logMethod === 'function') {
            logMethod(
                error,
                errorInfo,
                (generatedErrorId: string) => {
                    errorId = generatedErrorId;
                },
                false,
            );
        }

        this.setState({ errorId: errorId ?? null });

        if (!error.global) {
            HandleNotification(error, false);
        }
    }

    static contextType = UserContext;

    handleReresh = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.reload();
    };

    render() {
        const { children } = this.props;
        const { error, errorId } = this.state;

        if (error) {
            return (
                <ErrorHandlerStyle>
                    <OptimizedImage
                        src={buildImgUrl('img/illustrations/Totem_illustration-021.png')}
                        // alt={"Illustration d'un café renversé, illustrant un problème qui vient de survenir."}
                        width={350}
                        $margins={[0, 0, 1, 0]}
                    />
                    <ErrorHandlerTitle>Oups, il y a eu une petite erreur...</ErrorHandlerTitle>
                    <ErrorHandlerMessage>
                        Vous pouvez ouvrir le chat et indiquer votre
                        <br />
                        ticket d'erreur unique que voici :
                    </ErrorHandlerMessage>
                    <ErrorHandlerCode>
                        <code>ID: {errorId}</code>
                    </ErrorHandlerCode>
                    <ErrorHandlerMessage>
                        Pendant ce temps, essayez {/* eslint-disable-next-line */}
                        <a href="#" onClick={this.handleReresh}>
                            d'actualiser la page
                        </a>
                        {' !'}
                    </ErrorHandlerMessage>
                </ErrorHandlerStyle>
            );
        }

        return children;
    }
}
